import { useMemo } from 'react';

import { usePrevious } from '~/hooks/usePrevious';

export const useHasChanged = <T>(value: T): boolean => {
  const previousValue = usePrevious(value);

  return useMemo(() => previousValue !== value, [previousValue, value]);
};
